// Hàm chuyển từ camelCase sang snake_case
const camelToSnake = (str: string): string => {
    return str.replace(/[A-Z]/g, (match) => `_${match.toLowerCase()}`);
};

// Hàm chuyển đổi đối tượng từ camelCase sang snake_case
const convertToSnakeCase = (obj: Record<string, any>): Record<string, any> => {
    const result: Record<string, any> = {};

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const snakeKey = camelToSnake(key); // Chuyển camelCase thành snake_case
            const value = obj[key];

            // Nếu giá trị là đối tượng, đệ quy chuyển đổi
            if (value && typeof value === "object" && !Array.isArray(value)) {
                result[snakeKey] = convertToSnakeCase(value);
            } else if (Array.isArray(value)) {
                // Nếu giá trị là mảng, chuyển đổi từng phần tử trong mảng
                result[snakeKey] = value.map((item) =>
                    item && typeof item === "object" ? convertToSnakeCase(item) : item
                );
            } else {
                result[snakeKey] = value;
            }
        }
    }

    return result;
};

export default convertToSnakeCase;
